<template>
  <div class='kr-container'>
    <div class="kr-title">샤넬코리아 유한회사</div>
    <div class="kr-title">Chanel.com 이용 약관</div>

    <div class="kr-small-title">제1조(목적)</div>
    <div class="kr-text-content">이  약관은  샤넬코리아  유한회사가  운영하는  샤넬  공식  웹사이트(이하  “Chanel.com”)에서  제공하는  모든  서비스(이하  “서비스”)를  이용하는  자와  Chanel.com  간의  권리·의무  및  책임사항을  규정하는  데 그 목적이 있습니다.</div>
    
    <div class="kr-small-title">제2조(정의)</div>
    <div class="kr-text-content">
      <div class="kr-text">
        <div class="num">①</div>
        <div>“Chanel.com”란  샤넬이  재화  또는  용역(이하  “재화  등”)을  이용자에게  제공하기  위하여  컴퓨 터 등 정보통신설비를 이용하여 재화 등을 거래할 수  있도록 설정한 가상의 영업장을 의미하 며, 아울러 Chanel.com를 운영하는 사업자를 의미하기도 합니다.</div>
      </div>
      <div class="kr-text">
        <div class="num">②</div>
        <div>“이용자”란  Chanel.com에  접속하여  이  약관에  따라  Chanel.com가  제공하는  서비스를  받는  회 원 및 비회원을 의미합니다.</div>
      </div>
      <div class="kr-text">
        <div class="num">③</div>
        <div>“회원”은  Chanel.com  및  오프라인  매장(이하  “부티크”)에서  회원등록을  한  이용자로서,  사업적 인  판매를  목적으로  하는  상인이  아니라  개인적인  사용  목적으로  구매하는  이용자를  의미합 니다.</div>
      </div>
      <div class="kr-text">
        <div class="num">④</div>
        <div>“비회원”은  회원으로  가입하지  않고  Chanel.com이  제공하는  서비스를  이용하는  이용자로서,  사업적인  판매를  목적으로  하는  상인이  아니라  개인적인  사용  목적으로  구매하는  이용자를  의미합니다.  </div>
      </div>
      <div class="kr-text">
        <div class="num">⑤</div>
        <div>“Click-and-collect  주문”이란  이용자가  Chanel.com에서  결제한  재화를  배송  받지  않고  부티크 
에서 직접 수령하는 방식의 주문을 의미합니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제3조 (약관 등의 명시와 설명 및 개정)</div>
    <div class="kr-text-content">
      <div class="kr-text">
        <div class="num">①</div>
        <div>Chanel.com는  이  약관의  내용과  상호  및  대표자  성명,  영업소  소재지  주소(소비자의  불만을  
        처리할  수  있는  곳의  주소를  포함),  전화번호,  전자우편(e-mail)  주소,  사업자등록번호,  통신판 매업신고번호를  이용자가  쉽게  확인할  수  있도록  Chanel.com의  초기  서비스화면(전면)에  게시 합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 게재할 수 있습니다.  
        </div>
      </div>
      <div class="kr-text">
        <div class="num">②</div>
        <div>Chanel.com는  이용자가  약관에  동의하기에  앞서  약관에  정해져  있는  내용  중  주문철회,  배송 책임,  환불조건  등과  같은  중요한  내용을  이용자가  이해할  수  있도록  별도의  연결화면  또는  팝업화면 등에 게재합니다.  </div>
      </div>
      <div class="kr-text">
        <div class="num">③</div>
        <div>Chanel.com는  「전자상거래  등에서의  소비자보호에  관한  법률」,  「약관의  규제에  관한  법 률」,  「전자거래기본법」,  「전자서명법」,  「정보통신망  이용촉진  및  정보보호  등에  관한  법률」,  「소비자기본법」  등  관련  법령을  위배하지  않는  범위에서  이  약관을  개정할  수  있 습니다.  </div>
      </div>
      <div class="kr-text">
        <div class="num">④</div>
        <div>Chanel.com가  약관을  개정하는  경우  개정약관의  적용일자  및  개정사유를  명시하여  적용일자  7일  이전부터  적용일자  전일까지  전자우편  또는  문자를  통하여  고지합니다.  다만,  이용자에게  불리하게 	약관을 	개정하는 	경우에는 	최소 	30일의 	유예기간을 	두고 	고지합니다. 	이 	경우  Chanel.com는  개정  전  내용과  개정  후  내용을  명확하게  비교하여  이용자가  알기  쉽도록  표시 합니다.  </div>
      </div>
      <div class="kr-text">
        <div class="num">⑤</div>
        <div>Chanel.com가  개정약관을  고지하면서  이용자에게  기한  내에  거절의  의사표시를  하지  않으면  개정약관에  동의한  것으로  본다는  뜻을  명확하게  고지하였음에도  이용자가  그  기한  내에  명 시적으로  거절의사를  표시하지  아니한  경우  이용자가  개정약관에  동의한  것으로  봅니다.  이 용자가  개정약관의  적용에  동의하지  않더라도  Chanel.com는  개정약관  적용일자  이전에  체결 된  구매계약은  이행하여야  합니다.  단,  이용자가  개정약관에  동의하지  않으면  Chanel.com는  개정약관 적용 일자 이후의 서비스 제공을 거절할 수 있습니다. </div>
      </div>
      <div class="kr-text">
        <div class="num">⑥</div>
        <div>Chanel.com가  약관을  개정하는  경우  개정약관은  적용일자  이후에  체결되는  계약에만  적용되 고  개정약관  적용일자  이전에  체결된  계약에  대해서는  개정  전의  약관조항이  그대로  적용됩 니다.  다만  이미  계약을  체결한  이용자가  개정약관  조항의  적용을  받기를  원하는  뜻을  제4항 에  의한  개정약관의  고지기간  내에  Chanel.com에  통지하여  Chanel.com의  동의를  받은  경우에 는 개정약관이 적용됩니다. </div>
      </div>
      <div class="kr-text">
        <div class="num">⑦</div>
        <div>이  약관에서  정하지  아니한  사항과  이  약관의  해석에  관하여는  「전자상거래  등에서의  소비 자 보호에 관한 법률」, 「약관의 규제 등에 관한 법률」, 공정거래위원회가 정하는 「전자상 거래 등에서의 소비자보호지침」 및 관련 법령 또는 상관례에 따릅니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제4조(서비스의 제공 및 변경)</div>
    <div class="kr-text-content">
      <div class="kr-text">
        <div class="num">①</div>
        <div>Chanel.com는 다음의 서비스를 제공합니다. </div>
      </div>
      <ol>
        <li class="kr-text-li">재화 등에 대한 정보 제공 및 구매계약의 체결  </li>
        <li class="kr-text-li">구매계약이 체결된 제품의 배송  </li>
        <li class="kr-text-li">Live chat을 통한 고객 지원 서비스  </li>
        <li class="kr-text-li">샤넬 뷰티 앱 및 패션 앱과의 연동 서비스  </li>
        <li class="kr-text-li">스마트폰 단말기 위치정보를 활용한 위치기반 행사∙혜택 등 안내 서비스</li>
        <li class="kr-text-li">기타 Chanel.com가 정하는 업무 </li>
      </ol>
      <div class="kr-text">
        <div class="num">②</div>
        <div>Chanel.com가  이용자와  계약을  체결한  후  제공할  재화  등의  품절  또는  기술적  사양의  변경  등의  사유로  변경할  경우에는  변경사유를  이용자에게 통지  가능한  연락처로  즉시  통지하여야  합니다. 통지를 받은 이용자는 주문을 철회하거나 계약 내용의 변경에 동의할 수 있습니다 </div>
      </div>
    </div>

    <div class="kr-small-title">제5조(서비스의 중단)</div>
    <div class="kr-text-content">
      <div class="kr-text">
        <div class="num">①</div>
        <div>Chanel.com는  컴퓨터  등  정보통신설비의  보수점검,  교체  및  고장,  통신의  두절  등의      사유가  발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.  </div>
      </div>
      <div class="kr-text">
        <div class="num">②</div>
        <div>본 약관에서 달리 정하는 경우를 제외하고, 제1항의 사유로 Chanel.com 서비스의 제공이 일시 
적으로 중단된 경우, 이와 관련한 손해에 대해서는 Chanel.com는 고의 또는 과실이 없는 이상  이용자에 대하여 손해배상책임을 부담하지 않습니다. </div>
      </div>
      <div class="kr-text">
        <div class="num">③</div>
        <div>사업업종의  전환,  사업의  포기,  업체  간의  통합  등의  이유로  서비스  제공을  중단하는  경우에 
는 Chanel.com는 제8조에서 정한 방법으로 이용자에게 통지합니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제6조(회원가입) </div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>이용자는  Chanel.com가  정한  가입  방식에  따라  회원정보를  기입한  후  이  약관에  동의한다는  
의사표시를 함으로써 회원가입을 신청합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는  다음  각호에  해당하는  경우를  제외하고  제1항에  따라  회원가입을  신청한  이용 
자를 회원으로 등록합니다. </div>
      </div>
      <ol>
        <li class="kr-text-li">가입신청자가  이  약관  제7조  제3항에  의하여  이전에  회원자격을  상실한  적이  있는  경우,  
다만  제7조  제3항에  의한  회원자격  상실  후  3년이  경과한  자로서  Chanel.com의  회원  재 가입 승낙을 얻은 경우에는 예외로 함 </li>
        <li class="kr-text-li">등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
        <li class="kr-text-li">Chanel.com가  정한  구매  정책을  위반한  것으로  의심되는  고객이  Chanel.com가  요구한  소 
          명을 하지 않거나 또는 소명을 하였으나 의심이 해소되지 않은 경우</li>
        <li class="kr-text-li">회원가입  신청자가  매크로  프로그램을  사용하는  등  회원으로  등록하는  것이  Chanel.com 
의 기술상 현저히 지장이 있다고 판단되는 경우</li>
      </ol>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>만  14세  미만의  이용자는  샤넬  온라인  스토어  회원으로  가입할  수  없고  Chanel.com가  제공하 
는 서비스를 이용할 수 없습니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>CHANEL CODE  멤버십  위치기반서비스는  만  14세  이상을  대상으로  하며, 14세  미만  아동의  
개인위치정보는 이용∙제공되지 않습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑤</div>
        <div>회원은  본조  제1항에  의한  등록사항에  변경이  있는  경우,  지체  없이  Chanel.com의  마이  페이 
지에서 자신의 정보를 변경하는 방법 등으로 Chanel.com에게 변경사항을 알려야 합니다. </div>
      </div>
    </div>

    <div class="kr-small-title">제7조(회원 탈퇴 및 자격 상실 등)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>회원은 Chanel.com에 언제든지 탈퇴를 요청할 수 있으며 Chanel.com는 즉시 해당 이용자의 회 
원 등록 말소를 위한 절차를 밟습니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>회원이 다음 각호에 해당하는 경우 Chanel.com는 회원자격을 박탈할 수 있습니다.  </div>
      </div>
      <ol> 
        <li class="kr-text-li">1 년 이내에 단순 변심에 의한 환불을 총 5 회 이상 받은 경우</li>
        <li class="kr-text-li">정해진 구매제한 갯수를 초과하여 구매하거나 구매제한을 회피하기 위한 비정상적 구매행 
위를 하는 경우</li>
        <li class="kr-text-li">가입 신청 시에 허위 내용을 기입한 경우</li>
        <li class="kr-text-li">다른 사람의 Chanel.com 이용을 방해하거나 다른 사람의 정보를 도용하는 등 전자상거래  
질서를 위협하는 경우</li>
        <li class="kr-text-li">Chanel.com 를 이용하여 법령, 본 약관 또는 당사 정책에 위배되는 행위를 하는 경우</li>
        <li class="kr-text-li">타인의 명의를 도용한 경우</li>
        <li class="kr-text-li">기타 Chanel.com 가 정한 회원 자격 조건을 불충족하는 경우</li>
      </ol>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com는  회원자격  박탈  사유가  발생한  경우  회원에게  이를  고지하고,  회원등록  말소  전  7일 이상의 기간을 정하여 소명할 기회를 부여합니다.  회원이 Chanel.com가 요구한 소명을 하 지  않거나  또는  소명을  하였으나  소명  내용이  정당하지  않은  경우  Chanel.com는  회원  등록을  말소할 수 있습니다.  </div>
      </div>
    </div>

    <div class="kr-small-title">제8조(이용자에 대한 통지)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com가 회원에게 통지를 하는 경우, 회원이 회원가입 또는 회원정보 변경 시 기입한 연 
락처로 통지할 수 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는 불특정다수 회원에 대한 통지의 경우 1주일 이상 Chanel.com 내에 게시함으로써  
개별  통지에  갈음할  수  있습니다.  다만,  회원  본인의  거래와  관련하여  중대한  영향을  미치는  사항에 대하여는 제1항에 따라 개별 통지를 합니다. </div>
      </div>
    </div>

    <div class="kr-small-title">제9조(주문) </div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div>이용자는 Chanel.com 상에서 다음과 같은 또는 이와 유사한 순서로 구매를 주문하며, Chanel.com는  이용자가 구매 주문을 함에 있어서 다음의 각 내용을  알기 쉽게 제공합니다. 단, 회원인 경우 제2 호  및  제4호는  회원가입  단계에서  수집한  정보를  이용할  수  있고,  제3호는  연결화면  등을  통한  간이한 방법으로 제공할 수 있습니다.</div>
      </div>
      <ol> 
        <li class="kr-text-li">재화 등의 검색 및 선택</li>
        <li class="kr-text-li">성명, 주소, 전화번호 (또는 이동전화번호), 전자우편(e-mail) 주소 등의 입력</li>
        <li class="kr-text-li">약관 내용, 주문철회권이 제한되는 서비스, 배송료 및 기타 비용 등의 비용부담에 관한 내 용 확인</li>
        <li class="kr-text-li">이 약관에 동의하고 위 3 호의 사항을 확인하거나 거절하는 표시 </li>
        <li class="kr-text-li">재화 등의 구매주문 및 이에 관한 확인 또는 Chanel.com 의 확인에 대한 동의 </li>
        <li class="kr-text-li">결제방법의 선택 </li>
      </ol>
    </div>

    <div class="kr-small-title">제10조 (계약의 성립) </div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>구매계약은  이용자의  주문에  대한  Chanel.com의  승낙이  제12조  제1항의  수신확인통지  형태로  
이용자에게 도달한 시점에 성립한 것으로 봅니다.  </div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com의 승낙의 의사표시에는 이용자의 구매 신청에 대한 확인 및 판매 가능 여부, 구매 
주문의 정정, 취소 등에 관한 정보 등을 포함하여야 합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com는 구매 주문이 다음 각호에 해당하면 주문을 취소할 수 있습니다.</div>
      </div>
      <ol> 
        <li class="kr-text-li">주문 내용에 허위, 기재누락, 오기가 있는 경우</li>
        <li class="kr-text-li">제 2 조에서 정한 이용자 이외의 자에 의한 주문</li>
        <li class="kr-text-li">한 개의 ID 로 같은 날 동일 제품을 4 개 이상 구매한 경우</li>
        <li class="kr-text-li">재고가 부족한 경우</li>
        <li class="kr-text-li">기타 구매 주문이 매크로 프로그램 등을 사용한 것으로서 이에 대한 승낙이 Chanel.com 기 
술상 현저히 지장이 있다고 판단하는 경우</li>
      </ol>
    </div>

    <div class="kr-small-title">제11조(가격 정책 및 대금지급방법 등)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com에서  구매한  재화  등에  대한  대금은  다음  각  호의  방법으로  지급할  수  있습니다.  
Chanel.com는  이용자의  지급방법에  따라  재화  등의  대금에  어떠한  명목의  수수료도  추가하여  징수할 수 없습니다.  </div>
      </div>
      <ol> 
        <li class="kr-text-li">인터넷 뱅킹 등의 각종 계좌이체</li>
        <li class="kr-text-li">직불카드, 신용카드 등의 각종 카드 결제  </li>
        <li class="kr-text-li">휴대폰을 이용한 소액결제</li>
        <li class="kr-text-li">간편결제  </li>
        <li class="kr-text-li">기타 전자적 지급 방법에 의한 대금 지급 등</li>
      </ol>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는  웹사이트에  표시한  가격의  정확성을  기하기  위하여  최선을  다합니다.  다만,  이 용자가  주문한  재화의  가격에  오기가  발견될  경우, Chanel.com는  정상가격으로  주문을  할  것 인지, 아니면 주문을 취소할 것인지 여부를 구매자에게 이메일, 전화 등의 방법으로 재확인합 니다.  만약  구매자가  24시간  동안  연락을  받지  않는  경우,  해당  주문은  취소된  것으로  봅니 다.  </div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>이용자는  관련  법령에  따라  결제대금예치업무(에스크로)의  보호를  Chanel.com에  요청할  수  있 습니다.  </div>
      </div>
    </div>

    <div class="kr-small-title">제12조(수신확인통지․구매주문 변경 및 취소)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com는 이용자의 구매주문을 받은 즉시 이용자에게 수신확인통지를 합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>수신확인통지를  받은  이용자는  의사표시의  불일치  등이  있는  경우에는  수신확인통지를  받은  
후  일정기간  내(최대  30분)에 Chanel.com를  통하여  구매  주문을  취소할  수  있습니다.  단,  제11 조  제1항  제2호의  카드  결제  이외의  수단으로  결제하였거나,  제11조  제1항  제2호의  카드  결 제를  하였더라도  수신확인통지를  받은  후  30분이  경과한  경우에는  제15조의  주문철회에  관한  규정에 따릅니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>제2항에도  불구하고, Click-and-collect  주문의  경우,  재화가  수령  부티크에  입고된  날로부터  14 일  이내에  수령하지  않을  경우  해당  주문이  자동  취소되고, Click-and-collect  주문  결제  이후  수령 부티크 및 배송 방법을 변경할 수 없습니다. </div>
      </div>
    </div>

    <div class="kr-small-title">제13조(재화 등의 공급) </div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com는 이용자와 재화 등의 공급 시기에 관하여  별도로 약정하지 않은 한, 이용자가 청 
약을   한   날로부터   7일   이내에   예약주문,   포장   등  배송에   필요한   조치를   취합니다.   다만,  Chanel.com가  이미  재화  등의  대금의  전부  또는  일부를  받은  경우  대금을  받은  날부터  3영업 일 이내에 조치를 취합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는  이용자가  재화  등의  공급  절차  및  진행  사항을  확인하는데  필요한  조치를  취합 니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com는  이용자가  구매한  제품에  대한  배송수단,  수단별  배송비용  부담자,  수단별  배송 
기간 등을 명시합니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제14조(환급) </div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div>본  약관  제10조에  따라  계약이  성립되었음에도  불구하고, Chanel.com는  재고  상황에  따라  재화  등 의 판매를 제한할 수 있습니다. Chanel.com는 이용자가 주문한 재화 등을 재고 부족, 품절 등의 사 유로  인도할  수  없을  때에는  지체  없이  주문취소사실을  이용자에게  통지하고,  사전에  재화  등의  대금을  받은  경우에는  대금을  받은  날부터  3영업일  이내에  환급하거나  환급에  필요한  조치를  취 합니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제15조(주문철회 등) </div>
    <div class="kr-text-content"> 
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com와  재화  등의  구매에  관한  계약을  체결한  이용자는  재화  등을  배송  받은  날부터  7 
일 이내에 주문을 철회할 수 있습니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>제1항에도  불구하고,  다음  각호에  해당하는  경우에는  이용자는  반품  및  대금  환급을  요청할  
수 없습니다. </div>
      </div>
      <ol> 
        <li class="kr-text-li">이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(재화의 박스 또는 밀봉포 
장을 개봉하여 추가 포장비용 없이 재판매가 불가능한 경우를 포함하나, 배송용 박스 포장  훼손 및 상품 하자의 경우 등은 제외함)</li>
          <li class="kr-text-li">이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우 </li>
          <li class="kr-text-li">시간의 경과에 의하여 재판매가 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우</li>
          <li class="kr-text-li">이용자가 반환한 제품이 주문한 정품이 아닌 경우</li>
          <li class="kr-text-li">주문철회를 허용할 경우 Chanel.com 에 회복할 수 없는 중대한 피해가 예상되는 경우로서  
사전에 해당 거래에 대하여 별도로 그 사실을 고지하고 이용자의 동의를 받은 경우</li>
          <li class="kr-text-li">주문 시 동봉된 사은품, 샘플 또는 샤넬 로고가 들어간 포장패키지를 반환하지 않은 경우</li>
          <li class="kr-text-li">유료선물포장 서비스의 경우, 주문 철회시 유료선물포장 비용은 환급되지 않습니다.</li>
      </ol>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>제2항  제2호  내지  제6호의  경우에  Chanel.com가  사전에  주문철회  등이  제한되는  사실을  소비 
자가  쉽게  알  수  있는  곳에  명기하거나  안내하는  등의  조치를  하지  않은  경우에는  이용자의  주문철회 등이 제한되지 않습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>Click-and-collect 주문시 일반 주문과 동일한 방법으로 주문을 철회할 수 있으며, 수령 부티크 
에서 교환 또는 환불은 불가합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑤</div>
        <div>이용자는  제1항  및  제2항의  규정에도  불구하고  재화  등의  내용이  표시·광고  내용과  다르거나  
계약 내용과 다르게 이행된 때에는 당해 재화 등을 공급 받은 날부터 3개월 이내에 주문철회  등을 할 수 있습니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제16조(주문철회 등의 효과)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com는  이용자로부터  재화  등을  반환  받은  경우  반환일로부터  3영업일  이내에  이용자 
가  지급한  재화  등의  대금을  이용자에게  환급합니다.  단,  결제수단에  따라  대금  환급  일정은  상이할  수  있습니다.  결제수단  서비스를  제공한  사업자에  의한  지연이  아닌, Chanel.com가  이  용자에게  재화  등의  환급을  지연한  때에는  지연기간에  대하여  공정거래위원회가  정하여  고시 하는 지연이자율을 적용하여 산정한 지연이자를 지급합니다.  </div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는  제1항을  이행함에  있어  이용자가  신용카드  또는  전자화폐  등의  결제수단으로  재화 등의 대금을 지급한 때에는 지체없이 당해 결제수단을 제공한 사업자에게 재화 등에 대 한 대금의 청구를 정지 또는 취소할 것을 요청합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>주문철회  등의  경우  공급  받은  재화  등의  반환에  필요한  비용은  이용자가  부담합니다.  다만  재화  등의  내용이  표시·광고  내용과  다르거나  계약내용과  다르게  이행되어  주문철회  등을  하 는  경우  재화  등의  반환에  필요한  비용은  Chanel.com가  부담합니다. Chanel.com는  이용자에게  주문철회 등을 이유로 위약금 또는 손해배상을 청구하지 않습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>주문  철회  등의  경우  재화  등의  반품은  샤넬  지정  배송업체를  통해서만  가능합니다.  지정  배 송업체 	안내에도 	불구하고 	이용자가 	다른 	배송업체를 	통하여 	재화 	등을 	반품한 	경우  Chanel.com는  반품비용을  부담하지  않으며,  운송  중에  발생한  파손  또는  분실에  대하여  책임 이 없습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑤</div>
        <div>이용자가  재화  등을  제공  받을  때  배송비를  부담한  경우  Chanel.com는  주문철회시  제품  등의  
반품비용을 부담하는 주체를 이용자가 알기 쉽도록 명확하게 표시합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑥</div>
        <div>배송 옵션별 배송·반품 비용은 다음과 같습니다. 단, Click-and-collect 주문의 경우 일반 배송만  가능합니다. </div>
      </div>
      <ol>
        <li class="kr-text-li">일반 배송: 2,500원. 단, 총 구매금액이 30,000원 이상인 경우, 배송비 무료</li>
        <li class="kr-text-li">익일 또는 지정일 배송: 3,500원. 유료 서비스</li>
        <li class="kr-text-li">반품비용(단순변심에 의한 환불시 고객 부담): 5,000원(도서산간지역은 추가비용 발생) </li>
      </ol>
    </div>

    <div class="kr-small-title">제17조(상품평 등)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com에서 실제로 물건을 구매한 이용자만이 상품평을 작성할 수 있습니다. 이용자는 아 
무런  대가나  이익을  제공받지  않고  솔직한  의견  및  경험을  토대로  상품평  등을  작성하여야  합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>이용자가 	작성한 	상품평은 	공개적으로 	게시되기 	전 	Chanel.com의 	승인을 	받아야 	합니다.  Chanel.com은 이용자가 작성한 상품평이 Chanel.com의 지침을 준수하는지 여부를 판단할 권한 이 있습니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com는 이용자가 작성한 상품평이 사실의 측면에서 정확하지 아니하여 다른 이용자, 샤 넬,  또는  샤넬의  브랜드에  오인  또는  기타  손해를  초래할  수  있는  경우,  해당  상품평의  게시 를 제한할 수 있습니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>Chanel.com는  이용자가  작성한  상품평에  포함된  개인정보보호법  제23조  제1항에  따른  민감정 보(이하  “민감정보”라  한다)로  인하여  다른  이용자에게  손해를  초래할  수  있는  경우,  해당  상 품평의 게시를 제한할 수 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑤</div>
        <div>Chanel.com는  이용자가  작성한  상품평이  상품이  실제로  사용되는  조건과  달라  다른  이용자,  샤넬  또는  샤넬의  브랜드에  오인  또는  기타  손해를  초래할  수  있는  경우,  상품평의  게시를  제한할 수 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑥</div>
        <div>Chanel.com는 공개된 상품평에 답변하지 않으며, 조치나 답변이 가능한 상품평에 대해서는 상 
품평을 게시 하기 전이나 비공개 처리 후 고객에게 개인적으로 답변할 수 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑦</div>
        <div>Chanel.com는  직원들에게  상품평  작성을  요구하지  않으며,  직원  또는  알려진  브랜드  관련  인 
사의 상품평을 게시하지 않기 위하여 합리적으로 노력합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑧</div>
        <div>Chanel.com는  이용자가  Chanel.com에  작성하는  상품평,  질문,  코멘트,  대화  등(“상품평  등”)의  
          일부  또는  전부를  마케팅  목적으로  사용,  게시하고자  하는  경우,  이용자의  동의를  받아야  하 고,  이용자가  동의한  범위  내에서  상품평  등에  이용자의  이름  또는  다른  자료들을  함께  게시 할  수  있으며,  전반적인  의미가  변경되지  않는  한도  내에서  표현,  길이  등을  수정할  수  있습 니다.  이용자는  해당  상품평의  활용이  부적절하거나  동의한  범위  및  목적  외로  사용되는  경 우에는 Chanel.com에 이메일 등으로 의견을 제기할 수 있으며, Chanel.com은 그에 따른 적절한  절차를 마련하여 운영합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑨</div>
        <div>Chanel.com는 이용자가 작성한 모든 상품평 등을 평등하게 취급하나, 아래 각 호의 내용을 포 
함하는 상품평 등의 경우에는 게시하지 않습니다.</div>
      </div>
      <ol>
        <li class="kr-text-li">외설,  차별적  표현(인종차별,  증오,  신체적  위해,  폭력을  조장하는  콘텐츠  포함),  비속어  
등 공중이 이용하는 Chanel.com에 적합하지 않은 내용</li>
        <li class="kr-text-li">광고, 스팸 콘텐츠, 샤넬의 제품 및 서비스와 무관하거나 다른 제품, 제안, 또는 웹사이트 
를 표시하는 내용</li>
        <li class="kr-text-li">이용자가 소유하지 않거나 다른 권리를 침해하거나 적법한 권리를 확보하지 못한 자료</li>
        <li class="kr-text-li">이용자가 구매한 상품과 무관한 서비스 또는 물류에 관한 내용</li>
        <li class="kr-text-li">이메일 주소, URL(Chanel.com  제외), 전화번호, 주소 또는 기타 연락처 정보</li>
        <li class="kr-text-li">Chanel.com,  다른  사람  또는  단체의  명예를  훼손,  남용,  폄하하거나  맹목적으로  비난,  비 
방하는 내용</li>
        <li class="kr-text-li">의학적 조건 또는 효과에 관한 논평이나 불분명한 내용</li>
        <li class="kr-text-li">사기, 기만, 오도, 불법적이거나 불법적 활동을 조장하는 내용</li>
      </ol>

    </div>

    <div class="kr-small-title">제18조(Chanel.com의 의무)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com는  법령과  본  약관이  금지하는  행위를  하지  않으며  본  약관이  정하는  바에  따라  
지속적이고 안정적으로 재화 등을 제공하기 위해서 최선을 다합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는  이용자가  안전하게  인터넷  서비스를  이용할  수  있도록  이용자의  개인정보(신용 
정보 포함)보호를 위한 보안 시스템을 구축합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com는  이용자가  서비스를  이용함에  있어  Chanel.com의  고의  또는  중대한  과실로  인하 
여 입은 손해를 배상할 책임을 부담합니다. 단, 기술적인 보안 조치 및 필요한 조치를 했음에 도  불구하고  샤넬의  귀책  사유  없이  해킹  등  네트워크  상의  위험성에  의해  발생하는  예기치  못한  사고나  천재지변으로  인한  개인정보의  훼손,  서비스의  이상  및  이용자가  작성한  게시물 에 의한 분쟁에 관해서는 책임이 없습니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>Chanel.com는  상품에  대하여  「표시․광고의  공정화에 관한  법률」  제3조  소정의  부당한  표시 
·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑤</div>
        <div>Chanel.com는 사전에 정보 수신에 동의한 회원에 한해  정보성, 광고성 전자우편, 문자 메시지,  
우편물 및 각종 마케팅 정보를 보낼 수 있습니다. </div>
      </div>
    </div>

    <div class="kr-small-title">제19조(개인정보보호)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com는 서비스 제공을 위하여 필요 최소한의 개인정보를 수집합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는  이용자의  개인정보를  수집할  때  이용자에게  그  수집·이용  목적을  고지하고  동 
의를 받습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com는  수집된  개인정보를  수집·이용  목적  외의 용도로  이용할  수  없으며,  새로운  이용  
목적이  발생한  경우  또는  제3자에게  제공하는  경우에는  이용·제공  단계에서  당해  이용자에게  그  목적을  고지하고  동의를  받습니다.  다만,  관련  법령이  달리  정하는  경우에는  예외로  합니 다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>Chanel.com는  제2항과  제3항에  따라  이용자의  동의를  받아야  하는  경우에는  정보의  수집·이 용  목적,  제3자  정보  제공에  관한  사항(제공받는  자,  제공받는  자의  개인정보  이용  목적  및  제공하는  개인정보의  항목)  등  「정보통신망  이용촉진 및  정보보호  등에  관한  법률」  제22조  등에서  규정한  사항을  미리  명시하거나  고지해야  하며  이용자는  언제든지  동의를  철회할  수  있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑤</div>
        <div>이용자는  Chanel.com에  제공한  자신의  개인정보를  언제든지  열람할  수  있고,  오류를  정정할  수  있습니다.  이용자가 마이  페이지에서  직접  정정할  수  없는  오류의  정정을  요구한  경우에 는 Chanel.com는 지체없이 필요한 조치를 취할 것입니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑥</div>
        <div>Chanel.com는  개인정보  보호를  위하여  관리자를  한정하여  이용자의  개인정보에  접근할  수  있 
는  인원  수를  최소화하며, Chanel.com의  귀책사유로  인한  신용카드,  은행계좌  정보  등을  포함 한  이용자의  개인정보의  분실,  도난,  유출,  변조  등으로  인한  이용자의  손해에  대하여  모든  책임을 집니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑦</div>
        <div>Chanel.com  또는  그로부터  개인정보를  제공  받은  제3자는  관련  법령에서  달리  정하지  않는  
한 개인정보의 수집 또는 제공 받은 목적을 달성한 경우에는 당해 개인정보를 파기합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑧</div>
        <div>Chanel.com는 회원으로부터 사전 동의를 받아 회원들에게 제공하는 서비스의 양적, 질적 향상 
을  위하여  회원의  개인  식별이  가능한  개인정보를  맞춤서비스,  전자상거래,  커뮤니티,  컨텐츠,  모바일에  이용할  수  있습니다.  단,  이용자는  언제든지 Chanel.com의  마케팅, E-DM수신에  대한  거부  의사를  표시할  수  있으며, Chanel.com는  수신  거부  요청을  지체  없이  처리하여  고객불편 을 최소화 합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑨</div>
        <div>Chanel.com는  개인정보의  수집·이용·제공에  관한  동의란을  미리  선택한  것으로  설정하지  않습 니다.  또한  개인정보의  수집·이용·제공에  관한  이용자의  동의  거절  시  제한되는  서비스를  구 체적으로  명시하고,  필수수집항목이  아닌  개인정보의  수집·이용·제공에  관한  이용자의  동의  거절을 이유로 회원가입 등 서비스 제공을 제한하거나 거절하지 않습니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑩</div>
        <div>회원은  원하는  경우  언제든지  Chanel.com에  제공한  개인정보의  수집·이용에  대한  동의를  철 
회할 수 있으며 동의의 철회는 회원 탈퇴를 하는 것으로 이루어 집니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑪</div>
        <div>개인정보에 관한 자세한 사항은 개인정보 처리방침을 참조하시기 바랍니다.</div>
      </div>
    </div>
    
    <div class="kr-small-title">제19-2조(개인위치정보의 이용 또는 제공)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com는  개인위치정보를  이용하여  서비스를  제공하고자  하는  경우에는  미리  이용약관에  
명시한 후 개인위치정보주체의 동의를 얻어야 합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는 개인위치정보주체의 동의 없이 개인위치정보를 제3자에게 제공하지 않으며, 제3 
자에게  제공하는  경우에는  제공받는  자  및  제공  목적을  사전에  이용자에게  고지하고  동의를  받습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com이 	개인위치정보를 	개인위치정보주체가 	지정하는 	제3자에게 	제공하는 	경우  Chanel.com는 매회 개인위치정보주체에게 개인위치정보를 제공받는 자, 제공일시 및 제공목적 을  즉시  통보하거나,  개인위치정보주체의  동의를  받아  횟수나  기간을  정하여  제공  내역을  모 아서 통보합니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제19-3조(개인위치정보 이용·제공사실 확인자료의 보유)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com는  개인위치정보주체의  위치정보  이용·제공사실  확인자료를  위치정보시스템에  자 
동으로 기록하며, 관련 자료는 6개월 이상 보관합니다.  다만, 개인위치정보주체가 이용·제공에  관한  동의를  철회하는  경우  해당  부분과  관련된  위치정보  이용·제공사실  확인자료를  파기합 니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제19-4조(개인위치정보주체의 권리와 행사방법) </div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>개인위치정보주체는  언제든지  개인위치정보  이용∙제공에  관한  동의를  전부  또는  일부  철회할  
있으며,  언제든지  개인위치정보  이용∙제공의  일시적인 중지를  요구할  수  있습니다.  다만,  이러 한 경우 본건 서비스의 전부 또는 일부의 이용이 제한될 수 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>개인위치정보주체는  본인에  대한  개인위치정보  이용∙제공사실  확인자료  및  본인의  개인위치 정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률의 규정에 의하여 제3자에게  제공된  이유  및  내용에  대해  열람  또는  고지를  요구할  수  있고,  해당  자료  등에  오류가  있는  경우에는 그 정정을 요구할 수 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>개인위치정보주체는  고객센터(향수  및  화장품  제품  관련: 080-805-9638,  패션  및  워치  &  주얼 리  제품  관련: 080-805-9628, customer.service@chanel.co.kr)에  연락하여  언제든지  위  각  항에  따 른 권리를 행사할 수 있습니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제19-5조(개인위치정보의 보유목적 및 보유기간) </div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com은  Chanel.com이  제공하는  위치기반서비스의  제공,  관련  법령의  준수,  기타  개인위 
치정보주체가 동의한 목적을 위해 개인위치정보를 보유합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com은  제1항의  목적을  달성하는  데  필요한  기간  동안만  해당  개인위치정보를  이용합 
니다. 단, 관련 법령에 따라 개인위치정보를 보존할 의무가 있는 때에는 해당 법령에서 정하는 기 간 동안 개인위치정보를 보유하며, 상기 목적 이외의 목적으로는 일체 이용하지 않습니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제20조(회원의 ID 및 비밀번호에 대한 의무)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com가  관련  법령,  개인정보  처리방침,  본  약관  제18조에  의하여  책임을  지는  경우를  
제외하고, 회원 본인의 ID와 비밀번호에 관한 관리책임은 각 회원에게 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>회원은  자신의  ID  및  비밀번호를  도난  당하거나  제3자가  사용하고  있음을  인지한  경우에는  
즉시 Chanel.com에 통보하고 Chanel.com의 안내가 있는 경우에는 그에 따라야 합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>이용자가  본  약관에  규정된  이용자의  의무  조항을  어길  경우  Chanel.com는  해당  이용자의  계 
정 및 서비스 이용에 제한을 가할 수 있습니다. </div>
      </div>
    </div>

    <div class="kr-small-title">제21조(이용자의 의무)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>이용자는 다음 행위를 하여서는 안됩니다. </div>
      </div>
      <ol> 
        <li class="kr-text-li">회원가입을 포함한 각종 신청 또는 변경 시 허위 내용의 등록</li>
        <li class="kr-text-li">동일 이용자가 복수의 ID 를 생성하는 행위</li>
        <li class="kr-text-li">타인의 정보 도용 또는 유출</li>
        <li class="kr-text-li">제 2 조에서 정한 이용자의 자격에 반하는 주문</li>
        <li class="kr-text-li">Chanel.com 에 게시된 정보의 변경</li>
        <li class="kr-text-li">Chanel.com 가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시 </li>
        <li class="kr-text-li">Chanel.com 및 기타 제 3 자의 저작권 등 지적재산권에 대한 침해 </li>
        <li class="kr-text-li">Chanel.com 및 기타 제 3 자의 명예를 손상시키거나 업무를 방해하는 행위</li>
        <li class="kr-text-li">외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 Chanel.com 의 고 
객문의란 또는 기프트메시지란 등에 작성하는 행위 </li>
        <li class="kr-text-li">샤넬의 제품 구매한도 정책(같은 날 동일 제품 4 개 이상)을 위반하여 구매하는 행위</li>
      </ol>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는  이용자의  제1항의  행위에  대하여  이용자의  귀책사유가  있는  경우  이용자에게  
책임을 추궁할 수 있으며, Chanel.com는 어떠한 책임도 지지 않습니다.</div>
      </div>
    </div>
    
    <div class="kr-small-title">제22조 (CHANEL CODE)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>대한민국 	국적 	및 	국내거주 	외국인으로서 	샤넬 	향수 	및 	화장품 	제품을 	구매한 	회원은  
CHANEL CODE  멤버십 대상이 됩니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>CHANEL CODE는 6가지 컬러 등급으로 구성되며, 등급에 따라 신제품 샘플링, 뉴스레터 발송,  
각종 이벤트 초대, private session  및 exclusive  서비스 제공 혜택이 제공됩니다. CHANEL CODE 는  고객맞춤형  서비스를  위한  제도로서,  포인트나  할인  등  경제적인  혜택을  부여하지  않습니 다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>CHANEL CODE  등급은  최종  구매일로부터  1년간  유효하며,  최종  구매일을  기준으로  과거  1 년간의 방문 및 구매실적에 따라 결정됩니다. 구매내역의 경우 Chanel.com 구매내역과 오프라 인  매장(백화점  및  면세점  포함)의  백화점몰*의  구매내역이  합산됩니다. (*백화점  몰의  경우  일부 매장에 한함, 적립 가능 해당 백화점몰은 고객센터문의) </div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>유효기간  중  상위등급  요건을  충족할  경우,  그  즉시  승급되며(최대  30  영업일  이내  반영),  상 
위등급의  유효기간은  승급시점부터  기산합니다.  승급  후  제품  환불  등에  따라  승급  기준에  미달하게 되는 경우 승급이 취소될 수 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑤</div>
        <div>1년  유효기간  중에  구매실적이  없으면  해당  회원은  이전  등급에  상관  없이  welcome  등급이 됩니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑥</div>
        <div>CHANEL CODE에 따른 회원 권리 및 서비스 혜택은 타인에게 양도될 수 없습니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑦</div>
        <div>CHANEL CODE  멤버십의  위치기반서비스  기능은  무료로  제공되며,  별도로  이용요금을  과금 할  경우  미리  이러한  사실을  고지하고  개별적으로  해당  서비스를  구입한  이용자에게만  서비 스를 제공합니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">⑧</div>
        <div>CHANEL CODE의 구체적인 내용은 당사 정책 및 보다 개선된 고객서비스를 위하여 언제든지  
변경 또는 종료될 수 있습니다.</div>
      </div>
    </div>
    
    <div class="kr-small-title">제23조 (CHANEL FASHION)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>CHANEL Fashion 모바일 애플리케이션(“패션 앱”)에서 회원가입을 한 이용자 또는 회원 중 패션 앱을 
이용하는 회원에 대하여서는 본 조가 추가적으로 적용됩니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>
          <div>Chanel.com은 패션 앱에 대한 모든 권리, 소유권 및 이권을 보유하며, 패션 앱 상의 컨텐츠 및 애플리케이션(소셜 네트워크 웹사이트들 상의 컨텐츠 및 애플리케이션 포함)을 소유합니다.</div>
          <div>Chanel.com은 패션 앱 상의 모든 자료에 대한 저작권 일체를 소유하고 있거나, 제3자로부터 패션 앱의 자료를 사용할 수 있는 유효한 권리를 취득하였습니다. 또한, Chanel.com은 패션 앱 상에 사용되거나 패션 앱과 관련되어 사용되는 모든 상표, 서비스표, 상호, 로고 및 도메인명을 소유하고 있거나, 제3자로부터 그러한 자료를 사용할 수 있는 유효한 권리를 취득하였습니다. 명시적으로 허용되지 않은 목적으로 패션 앱 상의 자료를 변경하거나 사용하는 것은 Chanel.com의 저작권 및 기타 전유적인 권리에 대한 위반에 해당됩니다.</div>
          <div>Chanel.com의 사전 서면동의가 없는 한, 패션 앱의 어느 일부도 열람목적 이 외의 기타 목적을 위하여 여하한 방식으로 복사, 전재, 재발행, 업로드, 포스팅, 전송 또는 배포될 수 없습니다. 패션 앱 상의 어느 컨텐츠를 프레이밍(framing) 하거나 무단 링크하는 행위 또한 위 금지 행위에 포함됩니다.</div>
        </div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com은 <a href="https://www.chanel.com/kr/privacy-policy/">샤넬 개인정보 처리방침</a>에 따라 이용자의 개인정보를 처리하고, 이용자에게 개인화된 서비스와 브랜드 커뮤니케이션을 제공할 수 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>이 약관의 기타 조항은 패션 앱이 제공하는 서비스에 관련된 범위 내에서 Chanel.com과 이용자에게 적용됩니다.</div>
      </div>
    </div>
    
    <div class="kr-small-title">제24조(저작권의 귀속 및 이용제한)  </div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com가 작성한 저작물에 대한 저작권 기타 지식재산권은 Chanel.com에 귀속됩니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>이용자는  Chanel.com를  이용함으로써  얻은  정보  중  Chanel.com에  지적  재산권이  귀속된  정보 
를  Chanel.com의  사전  승낙  없이  복제,  전송,  출판,  배포,  방송  기타  방법에  의하여  영리  목적 으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다. </div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com는  약정에  따라  이용자에게  귀속된  저작권을  사용하는  경우  당해  이용자에게  통보 
하여야 합니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제25조(이용자 불만 처리)</div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com는 이용자의 편의를 위한 고객센터를 설치·운영합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com는  이용자로부터  제출되는  불만사항  및  의견을  우선적으로  처리합니다.  다만,  신속 
한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 통보합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">③</div>
        <div>Chanel.com와  이용자  간에  발생한  전자상거래  분쟁과  관련하여  이용자의  피해구제신청이  있 
는  경우에  소비자분쟁조정위원회,  전자거래분쟁조정위원회,  그  밖에  소비자보호  관련  법령 에 따라 설치·운영되는 분쟁조정기구의 조정에 따를 수 있습니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">④</div>
        <div>Chanel.com는  또는  개인위치정보주체는  위치정보와  관련된  분쟁에  대해  당사자간  협의가  이 루어지지  아니하거나  협의를  할  수  없는  경우에는  개인정보보호법에  따라  개인정보분쟁조정 위원회에 조정을 신청할 수 있습니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제26조(재판관할 및 준거법) </div>
    <div class="kr-text-content"> 
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com와  이용자  간에  발생한  분쟁은  제소  당시  이용자의  주소지  관할  법원  또는  주소가  
없는  경우에는  거소를  관할하는  법원을  1심  전속관할  법원으로  하여  소송으로  해결합니다.  다만,  제소  당시  이용자의  주소  또는  거소가  분명하지  않거나  외국  거주자의  경우에는  민사 소송법상 규정에 따른 관할법원에서 해결합니다.</div>
      </div>
      <div class="kr-text"> 
        <div class="num">②</div>
        <div>Chanel.com와 이용자 간의 전자상거래 관련 소송에는 대한민국 법률을 적용합니다.</div>
      </div>
    </div>

    <div class="kr-small-title">제27조(사업자 정보) </div>
    <div class="kr-text-content">
      <div class="kr-text"> 
        <div class="num">①</div>
        <div>Chanel.com의 상호, 주소, 전화번호는 다음과 같습니다. </div>
      </div>
      <div class="table">
        <table>
          <tr>
            <td class="label">상호</td>
            <td class="content">샤넬코리아 유한회사</td>
          </tr>
          <tr>
            <td class="label">주소</td>
            <td class="content">서울특별시 중구 세종대로9길 41, 11층(서소문동, 퍼시픽타워)</td>
          </tr>
          <tr>
            <td class="label">전화번호</td>
            <td class="content">
              향수 및 화장품 제품 관련: 080-805-9638,<br>
              패션 및 워치 & 주얼리 제품 관련: 080-805-9628
            </td>
          </tr>
          <tr>
            <td class="label">위치정보관리책임자</td>
            <td class="content">
              Technology & Digital Service (정보전략 및 디지털 서비스 팀),<br>
              개인정보보호책임자 (privacy.korea@chanel.com)
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="bylaw">
      <div class="title">* 부 칙 </div>
      <div class="line-text">이 약관은 2018년 10월 4일부터 시행합니다.</div>
      <div class="line-text">이 약관은 2019년 6월 1일에 개정되었습니다.</div>
      <div class="line-text">이 약관은 2021년 9월 7일에 개정되었습니다.</div>
      <div class="line-text">이 약관은 2023년 4월 28일에 개정되었습니다.</div>
      <div class="line-text">이 약관은 2023년 11월 29일에 개정되었습니다.</div>
      <div class="line-text">이 약관은 2025년 2월 3일에 개정되었습니다.</div>
    </div>
  </div>
</template>

<script>
import { setRemSize } from '@/utils/common'
export default {
  components: {},
    data() {
      return {

      };
    },
  computed: {},
  watch: {},
  mounted() {
    setRemSize();
    window.addEventListener('resize', this.setRemSize);
  },
  methods: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', setRemSize);
  },
}
</script>
<style lang='scss' scoped>
.kr-container{
  max-width: 100rem;
  margin: 0 auto;
  padding: 2rem;
  line-height: 2rem;
  color: #1D1D1D;
  box-sizing: border-box;
  .kr-title{
    font-size: 1.8rem;
    line-height: 3.6rem;
    text-align: center;
  }
  .kr-small-title{
    font-size: 1.2rem;
    line-height: 2.4rem;
    margin-top: 2rem;
    margin-bottom: 0.5rem;
  }
  .kr-text-content{
    font-size: 1.2rem;
    .kr-text{
      font-size: 1.2rem;
      display: flex;
      .num{
        margin-right: 0.5rem;
      }
    }
    ol{
      padding-left: 3rem;
      .kr-text-li{
        padding-left: 0.5rem;
      }
    }
  }
  .table{
    margin-top: 1rem;
    table{
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #000;
      tr{
        border-bottom: 1px solid #000;
        &:last-child{
          border-bottom: none;
        }
        td{
          padding: 1rem;
          border-right: 1px solid #000;
          vertical-align: middle;
          text-align: center;
          &:last-child{
            border-right: none;
          }
          &.label{
            background-color: #f5f5f5;
            width: 30%;
            font-weight: normal;
          }
          &.content{
            background-color: #fff;
            width: 70%;
          }
        }
      }
    }
  }

  .bylaw{
    margin: 3.6rem 0 0.5rem;
  }
}
</style>